export default {
      id: "oc-bill-resource-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-bill-resource",
      toString: function () {
        return this.url;
      }
    }